import { createSelector } from 'reselect';

import orderBy from 'lodash/orderBy';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

import { getDataMapEntities } from '../entities';
// import { dataMapMethods } from '../../lib/DataMapsProcessor';

const getDataMapSchemas = (state) => state.dataMaps.schemas;

export const getSortedDataMaps = createSelector(
  [getDataMapEntities, getDataMapSchemas], //pick off a piece of state
  (allDataMapEntities, schemas) => {
    const dataMaps = merge({}, allDataMapEntities, schemas);
    let sortedEntities = orderBy(dataMaps, ['name'], ['asc']);
    //TODO : temp hack to avoid dispatch mutation on transform editor!!
    return cloneDeep(sortedEntities);
  },
);
